import React from 'react';
import { motion } from 'framer-motion';

interface ActionButtonsProps {
  resultId: number;
  onView: () => void;
  onDelete: () => void;
  whatsappLink?: string | null; // Link para WhatsApp
}

const ActionButtons: React.FC<ActionButtonsProps> = ({ resultId, onView, onDelete, whatsappLink }) => {
  return (
    <div className="flex items-center gap-2">
      {whatsappLink && (
        <motion.a
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          className="p-2 rounded-lg hover:bg-green-100 dark:hover:bg-green-900/30 transition-colors flex-shrink-0"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          title="Enviar mensagem no WhatsApp"
          onClick={(e) => e.stopPropagation()}
        >
          <img
            src={`${process.env.PUBLIC_URL}/whatsapp-logo.png`}
            alt="WhatsApp"
            className="w-5 h-5 flex-shrink-0"
          />
        </motion.a>
      )}

      <motion.button
        onClick={onView}
        className="p-1.5 rounded-md hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
        whileHover={{ scale: 1.1, rotate: 5 }}
        whileTap={{ scale: 0.9 }}
        title="Visualizar Detalhes"
      >
        <span className="material-symbols-outlined text-lg text-gray-600 dark:text-gray-400">
          visibility
        </span>
      </motion.button>

      <motion.button
        onClick={onDelete} // Usando o novo handler
        className="p-1.5 rounded-md hover:bg-red-100 dark:hover:bg-red-900/30 transition-colors"
        whileHover={{ scale: 1.1, rotate: -5 }}
        whileTap={{ scale: 0.9 }}
        title="Excluir"
      >
        <span className="material-symbols-outlined text-lg text-red-600 dark:text-red-400">
          delete
        </span>
      </motion.button>
    </div>
  );
};

export default ActionButtons;